import { Table } from '@tanstack/react-table';
import Pagination from './Pagination';
import { useEffect } from 'react';
import { useTableViewStateContext } from '../TableViewStateContextProvider';
import { useTableContext } from '../ColumnFilters/TableContextProvider';

interface TanStackPaginationProps<T> {
	table: Table<T>;
	options?: number[];
}

function TanStackPagination<T>({
	table,
	options,
}: TanStackPaginationProps<T>): JSX.Element {
	const { updateViewState } = useTableViewStateContext<T>();
	const { tableId } = useTableContext<T>();

	const paginationState = table.getState().pagination;
	const { pageIndex, pageSize } = paginationState;
	const pageCount = table.getPageCount();

	const correctedPageIndex =
		pageIndex >= pageCount ? Math.max(pageCount - 1, 0) : pageIndex;

	if (correctedPageIndex !== pageIndex) {
		table.setPageIndex(correctedPageIndex);
	}

	useEffect(() => {
		updateViewState(tableId, { pageIndex: correctedPageIndex, pageSize });
	}, [correctedPageIndex, pageSize, tableId, updateViewState]);

	return (
		<Pagination
			pageIndex={correctedPageIndex}
			setPageIndex={(pageIndex: number) => table.setPageIndex(pageIndex)}
			pageSize={pageSize}
			setPageSize={(pageSize: number) => table.setPageSize(pageSize)}
			pageCount={pageCount}
			paginationOptions={options}
		/>
	);
}

export default TanStackPagination;
